import React from 'react'
import cl from 'classnames'
import {
  SectionContainer,
  TabsLine
} from 'components/shared'
import styles from './OverviewStats.module.scss'
import { inject } from 'mobx-react'
import {
  STATISTICS_OVERVIEW_STORE
} from 'store'
import { observer } from 'mobx-react-lite'
import {
  PeriodChart
} from 'components/charts'
import { OverviewStatsProps } from './OverviewStats.types'
import { OverviewExpandableSection } from './OverviewExpandableSection'
import { OverviewProjectsTable } from './OverviewProjectsTable'
import { SectionHeader } from '../common/SectionHeader'
import { IconStatistics } from 'assets'

const OverviewStatsComponent = (props: OverviewStatsProps) => {
  const {
    [STATISTICS_OVERVIEW_STORE]: {
      periodFilter,
      onPeriodFilterSelect,
      customPeriod,
      onCustomPeriodSelect,
      onSelectedTabChange,
      getOverviewTabs
    },
    className,
    style,
    renderDashboardVersion
  } = props

  return (
    <SectionContainer
      className={cl(styles.unsetPosition, className)}
      style={style}
    >
      <SectionHeader
        label={renderDashboardVersion ? 'Statistic overview' : 'Overview'}
        boldLabel={renderDashboardVersion}
        labelIcon={renderDashboardVersion && IconStatistics}
        onPeriodFilterSelect={onPeriodFilterSelect}
        period={customPeriod}
        periodFilter={periodFilter}
        setPeriod={onCustomPeriodSelect}
      />
      <TabsLine
        tabs={getOverviewTabs()}
        onSelectedTabChange={onSelectedTabChange}
      />
      <OverviewExpandableSection
        initialIsExpandedState={renderDashboardVersion}
      />

      {!renderDashboardVersion && (
        <>
          <OverviewProjectsTable />
          <PeriodChart />
        </>
      )}
    </SectionContainer>
  )
}

const OverviewStats = inject(
  STATISTICS_OVERVIEW_STORE
)(observer(OverviewStatsComponent))
export { OverviewStats }
